import { render, staticRenderFns } from "./Paying.vue?vue&type=template&id=2cf3dc12&scoped=true&"
import script from "./Paying.vue?vue&type=script&lang=js&"
export * from "./Paying.vue?vue&type=script&lang=js&"
import style0 from "./Paying.vue?vue&type=style&index=0&id=2cf3dc12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf3dc12",
  null
  
)

export default component.exports